import React, { forwardRef } from 'react';
import styled, { stylesToResponsiveCssPropsByKeys } from '@grebban/style-system-react';
import applicationBrandingTypography from 'config/branding/typography';
import Button from 'components/Button';

/* --------------- Styled components --------------- */

const Wrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 20px;
    border-bottom: 1px solid var(--stroke-heavy);
    padding: 10px 0;
`;

const Input = styled('input')`
    flex: 1;
    min-width: 0;
    color: var(--ui-secondary);
    background: transparent;
    border: none;
    outline: none;

    &::placeholder {
        color: var(--ui-primary);
    }

    &:placeholder-shown {
        caret-color: var(--ui-primary);
    }
`;

const ActionButton = styled(Button)`
    flex-shrink: 0;
`;

/* --------------- Component --------------- */

export interface SearchInputFieldAction {
    label: string;
    onClick: () => void;
    typography?: (string | null)[];
}

export interface SearchInputFieldProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
    value: string;
    onChange: (value: string) => void;
    typography?: (string | null)[];
    action?: SearchInputFieldAction;
}

const SearchInputField = forwardRef<HTMLInputElement, SearchInputFieldProps>(
    ({ value, onChange, typography, action, className, ...rest }, ref) => (
        <Wrapper className={className}>
            <Input
                ref={ref}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                {...(typography
                    ? (stylesToResponsiveCssPropsByKeys(
                          typography as string[],
                          applicationBrandingTypography,
                      ) as Record<string, unknown>)
                    : {})}
                {...rest}
            />
            {action && (
                <ActionButton type="button" onClick={action.onClick} typography={action.typography}>
                    {action.label}
                </ActionButton>
            )}
        </Wrapper>
    ),
);

SearchInputField.displayName = 'SearchInputField';

export default SearchInputField;
